import { Routes } from "@angular/router";
import { MainLayoutComponent } from "./shared/layouts/main-layout/main-layout.component";
import { encQueryGuard } from "./shared/guards/enc.guard";
import { ErrorComponent } from "./modules/error/error.component";
import { AboutPSComponent } from "./modules/about-ps/about-ps.component";
import { GetHelpComponent } from "./modules/get-help/get-help.component";
import { PolicyFaqFullComponent } from "./modules/policies/policy-faq-full/policy-faq-full.component";
import { PolicyEnum } from "./modules/coverages/_constants";

export const routes: Routes = [
    {
        path: "",
        component: MainLayoutComponent,
        canActivate: [encQueryGuard],
        loadChildren: () => import("./modules/policies/policies.routes").then((m) => m.routes),
    },
    {
        path: "coverages",
        component: MainLayoutComponent,
        canActivate: [encQueryGuard],
        loadChildren: () => import("./modules/coverages/coverages.routes").then((m) => m.routes),
    },
    {
        path: "claims",
        component: MainLayoutComponent,
        canActivate: [encQueryGuard],
        loadChildren: () => import("./modules/claims/claims.routes").then((m) => m.routes),
    },
    {
        path: "coc",
        component: MainLayoutComponent,
        loadChildren: () => import("./modules/coc/coc.routes").then((m) => m.routes),
    },
    {
        path: "error",
        component: ErrorComponent,
    },
    {
        path: "aboutps",
        component: MainLayoutComponent,
        children: [
            {
                path: "",
                component: AboutPSComponent,
            }
        ]
    },
    {
        path: "gethelp",
        component: MainLayoutComponent,
        children: [
            {
                path: "",
                component: GetHelpComponent,
            },
            {
                path: "policy-faq-full-travel",
                component: PolicyFaqFullComponent,
                data: {
                    policy: PolicyEnum.TravelProtectPlus,
                },
            },
            {
                path: "policy-faq-full-bill",
                component: PolicyFaqFullComponent,
                data: {
                    policy: PolicyEnum.BillProtect,
                },
            },
            {
                path: "policy-faq-full-lifestyle",
                component: PolicyFaqFullComponent,
                data: {
                    policy: PolicyEnum.LifestyleProtectPlus,
                },
            },
        ]
    },
];
